import { Component, input, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { ColumnConfig } from '../../models/column-config.model';


@Component({
  selector: 'app-form-field',
  standalone: false,  
  templateUrl: './form-field.component.html',
  styleUrl: './form-field.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class FormFieldComponent {  
  @Input() column!: ColumnConfig;  
  @Input() controlName!: string;  
  @Input() inputId!: string; 

  constructor(private controlContainer: ControlContainer) {}

  get control() {
    return this.controlContainer.control?.get(this.controlName);
  }
}

